import { handleTouchEvents } from '../../utilities/touchEvent'

document.addEventListener('DOMContentLoaded', () => {
  handleTouchEvents('[data-mp-block-layout="instant-play-games"]')
})
